import useFirebaseData from "./useFirebaseData";

const useFirebaseUserData = () => {
  return useFirebaseData<Record<string, any>>("/userdata");
};

export default useFirebaseUserData;
